var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/uid.js
// module id = 387
// module chunks = 1